/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingEditorRpc
 */
import * as References from './MarketplaceListingEditorRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingEditorRpc#getDetails
 */
export const GET_DETAILS_QUERY_FIELD_NAME = 'com_hubspot_marketplace_listing_details_rpc_MarketplaceListingEditorRpc_getDetails';
export const GET_DETAILS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_DETAILS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getDetailsRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingEditorRpc#getDraftListing
 */
export const GET_DRAFT_LISTING_QUERY_FIELD_NAME = 'com_hubspot_marketplace_listing_details_rpc_MarketplaceListingEditorRpc_getDraftListing';
export const GET_DRAFT_LISTING_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_DRAFT_LISTING_QUERY_FIELD_NAME,
  args: ['listingId', 'language'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getDraftListingRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});